var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Chart } from '@kaizenplatform/kaizen-chartjs';
var ExtendedChart = /** @class */ (function (_super) {
    __extends(ExtendedChart, _super);
    function ExtendedChart(_a) {
        var chart = _a.chart, config = _a.config;
        var _this = _super.call(this, chart) || this;
        _this.config = config;
        return _this;
    }
    ExtendedChart.fromJSON = function (json) {
        var _a = Object.assign({}, json), chart = _a.chart, config = _a.config;
        return new ExtendedChart({
            chart: chart,
            config: config,
        });
    };
    return ExtendedChart;
}(Chart));
export default ExtendedChart;
